import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './BindingPage.module.scss';
import toyotaLogo from '../../assets/TOYOTA LOGO - Horizontal.svg';
import successSvg from '../../assets/success.svg';

export default function BindingSuccess() {
  const lineOAUrl = process.env.REACT_APP_LINE_OA_URL;
  const [countdown, setCountdown] = useState(3);  // 3秒後跳轉

  const handleCountdownComplete = () => {
    window.location.href = lineOAUrl;
  };

  useEffect(() => {
    if (countdown === 0) {
      handleCountdownComplete();
      return;
    }

    const timer = setTimeout(() => {
      setCountdown(prev => prev - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [countdown]);

  return (
    <div className="center-viewport">
        <div className="toyota-header">
          <Link to="/">
            <img className="toyota-logo" src={toyotaLogo} alt="TOYOTA LOGO" style={{height: '20px', width: 'auto', display: 'block', margin: '0 auto', cursor: 'pointer'}} />
          </Link>
        </div>
          <div className={styles['center-card']}>
            <div style={{position: 'relative', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
              <img src={successSvg} alt="綁定成功" className={styles['status-icon']} style={{position: 'relative', zIndex: 1}} />
            </div>
            <div className={styles['status-title']}>綁定成功</div>
            <div className={styles['status-desc']}>{countdown} 秒後將回到 LINE</div>
          </div>
    </div>
  );
} 